import React, { useEffect } from 'react';
import logo from '../imgs/logo.png'; 
import '../assets/styles.css';


const Footer = () => {
  useEffect(() => {
    // Scroll to top button functionality
    const goTopBtn = document.getElementById('goTopBtn');
    
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        goTopBtn.style.display = 'block';
      } else {
        goTopBtn.style.display = 'none';
      }
    };
    
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    if (goTopBtn) {
      goTopBtn.addEventListener('click', scrollToTop);
    }
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (goTopBtn) {
        goTopBtn.removeEventListener('click', scrollToTop);
      }
    };
  }, []);

  return (
    <>
      <div className="floating-icons">
        <a href="https://wa.me/+919963363021" target="_blank" rel="noopener noreferrer" title="WhatsApp">
          <i className="fab fa-whatsapp"></i>
        </a>
        <a href="https://www.instagram.com/genesequencingindia/" target="_blank" rel="noopener noreferrer" className="instagram" title="Instagram Message">
          <i className="fab fa-instagram"></i>
        </a>
      </div>

      <button id="goTopBtn" title="Go to top">&#8679;</button>

      <footer className="footer section">
        <div className="container">
          <div className="footer-col">
            <img src={logo} alt="Geneseq Logo" className="footer-logo" />
            <p>Gene Sequencing India Pvt. Ltd,. &copy; 2025</p>
          </div>
          {/* <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#services">Services</a></li>
              <li><a href="#products">Products</a></li>
              <li><a href="#downloads">Downloads</a></li>
            </ul>
          </div> */}
          <div className="footer-col">
            <h4>Contact</h4>
            <p>
              <span><i className="icon-map"></i> Plot.No. 24, Kakatiya Colony, Chengicherla, Hyderabad, Medipally Mandal, Medchal Malkajgiri District, Telangana. 500092</span><br />
              <span><i className="icon-phone"></i> +91-9963363021, 7780276536</span><br />
              <span><i className="icon-mail"></i> info@gsiin.com</span>
            </p>
            
          </div>
        </div>
        <div className="footer-bottom">
          &copy; 2025 Gene Sequencing India Pvt. Ltd,. All rights reserved.
        </div>
      </footer>
    </>
  );
};

export default Footer;
